// extracted by mini-css-extract-plugin
export default {"paiTopo":"ListarUser_paiTopo__tzgpH","pai":"ListarUser_pai__myWPo"};